import { render, staticRenderFns } from "./PointsIndex.vue?vue&type=template&id=3cec5203"
import script from "./PointsIndex.vue?vue&type=script&lang=js"
export * from "./PointsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports